import '@angular/compiler';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalKioskPrintComponent } from './portal.kiosk.print/portal.kiosk.print.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalKioskCreateComponent } from './portal.kiosk.create/portal.kiosk.create.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalKioskCameraComponent } from './portal.kiosk.camera/portal.kiosk.camera.component';
import { PortalKioskMapComponent } from './portal.kiosk.map/portal.kiosk.map.component';
import { PortalKioskPreparingComponent } from './portal.kiosk.preparing/portal.kiosk.preparing.component';
import { PagePicComponent } from './page.pic/page.pic.component';
import { PortalKioskQuizComponent } from './portal.kiosk.quiz/portal.kiosk.quiz.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { ComponentCardComponent } from './component.card/component.card.component';
import { PortalKioskFinishComponent } from './portal.kiosk.finish/portal.kiosk.finish.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PortalKioskScoreComponent } from './portal.kiosk.score/portal.kiosk.score.component';
import { PortalKioskCharacterComponent } from './portal.kiosk.character/portal.kiosk.character.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalKioskResultComponent } from './portal.kiosk.result/portal.kiosk.result.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PageMainComponent,
        PortalKioskPrintComponent,
        PortalSeasonLoadingComponent,
        PortalSeasonPagenationComponent,
        PortalKioskCreateComponent,
        PortalSeasonViewerTreeComponent,
        PortalKioskCameraComponent,
        PortalKioskMapComponent,
        PortalKioskPreparingComponent,
        PagePicComponent,
        PortalKioskQuizComponent,
        PortalSeasonUiDropdownComponent,
        LayoutNavbarComponent,
        LayoutEmptyComponent,
        ComponentCardComponent,
        PortalKioskFinishComponent,
        ComponentNavComponent,
        PortalKioskScoreComponent,
        PortalKioskCharacterComponent,
        PortalSeasonLoadingHexaComponent,
        PortalSeasonAlertComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonStatusbarComponent,
        PortalSeasonTabComponent,
        PortalKioskResultComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }